/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {translate} from '@ion/core/src/locale/locale';
import {IonSnackbar} from '@ion/dls/src/notifications/IonSnackbar';
import {toggleUserPrompt} from '@/store/actions/user-prompt';
import {ApplicationState} from '@/store/reducers';

/**
 * This is a user alert component that will display a snack if the action is
 * dispatched to display the IonSnackbar
 */
export const GlobalUserPrompt = () => {
  const dispatch = useDispatch();
  const {
    display: displaySnack,
    text: snackText,
    type,
    translateText,
    translateOption,
    actionLabel,
    autoHide,
    customDismissLabel,
    onDismiss,
    onAction,
    autoHideDuration,
    partialSuccessState
  } = useSelector(({userPrompt}: ApplicationState) => userPrompt.notification);

  const handleClose = function() {
    dispatch(toggleUserPrompt({display: false}));
  };

  const snackMessage = translateText ? translate(snackText, translateOption) : snackText;

  return (
    <IonSnackbar show={displaySnack}
      onAction={onAction !== null ? onAction : handleClose}
      partialSuccessState={partialSuccessState}
      message={snackMessage}
      autoHideDuration={autoHide ? autoHideDuration : null}
      actionLabel={translate(actionLabel)}
      customDismissLabel={translate(customDismissLabel)}
      onClose={handleClose}
      onDismiss={onDismiss}
      type={type} />
  );
};

export default GlobalUserPrompt;
